<template>
    <div>
        <div class="row"
             style="margin-bottom: 0;">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <h5 class="center-align white-text">
                    Не привязанные камеры
                </h5>
                <div class="row"
                     style="margin-bottom: 0;">
                    <div class="input-field col s12 m5 l5 xl5">
                        <input id="first_name2"
                               type="text"
                               @keyup="search($event)"
                               class="white-text">
                        <label class="white-text"
                               for="first_name2">Search</label>
                    </div>
                    <div class="col s12 m4 l4 xl4 main">
                        <a @click="provision"
                           style="margin: 5px 0;"
                           class="btn teal lighten-1 waves-effect
                    waves-light btn-small width-btn col s15 m8 l8 xl8">
                            <i class="material-icons left">save</i>Привязать камеры</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <table class="highlight card bg centered">
                    <thead>
                    <tr>
                        <th>убрать из списка</th>
                        <th>серийный номер</th>
                        <th>имя</th>
                        <th>Agent ID</th>
                        <th class="hide-on-small-and-down">дата добавления</th>
                        <th class="hide-on-small-and-down">текущий статус</th>
                        <th>видео</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="camera.agent_serial"
                        data-id="cameras"
                        :data-search="camera.agent_serial"
                        v-for="camera in cameras">
                        <td>
                            <div>
                                <a
                                        @click="deleteCamera(camera.name)"
                                        style="width: 50px;"
                                        class="btn red darken-3 waves-effect
									    waves-light btn-small center">
                                    <i class="material-icons">delete</i>
                                </a>
                            </div>
                        </td>
                        <td>{{camera.agent_serial}}</td>
                        <td>{{camera.name}}</td>
                        <td>{{camera.agent_id}}</td>
                        <td>{{camera.created_at}}</td>
                        <td class="hide-on-small-and-down">
                            <i class="material-icons  darken-3"
                               :class="camera.online ?  'green-text' : 'red-text'">
                                {{camera.online ? "check_circle_outline" : "highlight_off"}}
                            </i>
                        </td>
                        <td>
                            <div>
                                <a v-if="camera.online"
                                   @click="playVideo(camera.name)"
                                   style="width: 50px;"
                                   class="btn indigo darken-3 waves-effect
									    waves-light btn-small center">
                                    <i class="material-icons">play_arrow</i>
                                </a>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import {eventEmitter} from "../../main";
    import setRules from "../../assets/setRules";
    import swal from "sweetalert2";
    import Cameras from "../../plugins/controllers/cameras";

    export default {
        name: "NotProvisionedCameras",
        data() {
            return {
                cameras: []
            }
        },
        methods: {
            search(e) {
                let elements = document.querySelectorAll('[data-id="cameras"]');
                Array.from(elements).forEach(elem => {
                    if (
                        elem.attributes.getNamedItem("data-search").value.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1
                    ) {
                        if (elem.classList.contains("hidden")) {
                            elem.classList.remove("hidden");
                        }
                    } else {
                        elem.classList.add("hidden");
                    }
                });
            },
            provision() {
                const provisionUrl = 'https://peeklio.tv.kvant-telecom.ru/provision/get_owners_to_cameras/31E34648D6242AE7C5F304428740D64873C358D50944A617DFC74D6F24803284';
                swal.queue([{
                    title: 'Привязать камеры с агентом к пользователям?',
                    confirmButtonText: 'Привязать',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return fetch(provisionUrl)
                            .then(response => response.json())
                            .then(data => {

                                if (typeof data.message !== "undefined") {
                                    swal.insertQueueStep(data.message);
                                }

                                if (data.provisioned_cams.length > 0) {
                                    let string = 'Привязанные камеры: ';
                                    data.provisioned_cams.forEach(function (element) {
                                        string = string + element.agent_serial + ' ';
                                    });
                                            this.$toast.success({
                                                title: "Привязанные камеры:",
                                                message: string
                                            });
                                            this.getApiData();
                                } else {
                                            this.$toast.error({
                                                title: "Привязанные камеры:",
                                                message: "Ни одна из камер не была привязанна"
                                            });
                                }
                            })
                            .catch(() => {
                                this.$toast.error({
                                    title: "Все пропалою. Ничего не работает",
                                    message: "Зовите фиксиков!!!"
                                });
                            })
                    }
                }])
            },
            getApiData() {
                Cameras.getNotProvisionedCameras().then((response) => {
                    setRules(response);
                    this.cameras = response.data;
                    //    console.log(response.data);
                }).catch(e => {
                    this.setAuth(true);
                    this.setShowMenu(false);
                    console.log("Admins", e);
                    if (e.message.toLowerCase() === "network error") {
                        this.$toast.error({
                            title: "Ошибка с соединением",
                            message: "Проблемы с интернет-подключением или с доступом к серверу"
                        });
                    } else {
                        this.$toast.error({
                            title: "Произошла ошибка",
                            message: "Авторизуйтесь с вашей учетной записи"
                        });
                    }
                })
                    .then(() => {
                        // preload.hidden();
                        if (!this.e) {
                            let elements = document.querySelectorAll(".tooltips");
                            this.e = M.Tooltip.init(elements, {
                                position: "left"
                            });
                        }
                    });
            },
            deleteCamera(name) {
                console.log("deleteCamera");
                console.log(name);
                swal.fire({
                        title: 'Отключить камеру?',
                        text: "Камера больше не будет пытаться запровижиться!",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Отмена',
                        confirmButtonText: 'Отключить!'
                    }).then((result) => {
                        if (result.value) {
                            Cameras.disableCameraWithAgent(name).then((res) => {
                                setRules(res);
                                this.getApiData();
                                this.$toast.success({
                                    title: "Камера отключенна",
                                    message: "Можете продолжить редактирование"
                                });
                            }).catch(e => {
                                console.log(e);
                                this.setAuth(true);
                                this.setShowMenu(false);
                                this.$toast.error({
                                    title: "Не удалось отключить камеру",
                                    message: "Свяжитесь с администратором сервиса"
                                });
                            });
                        }
                    })
            },
            playVideo(name) {
                this.$router.push(`/cameras/video/${name}`);
                // console.log("playVideo");
                // console.log(name);
            },
            ...mapMutations([
                "setAuth",
                "setShowMenu"
            ]),
        },
        computed: {
            ...mapState(["tokenSuccess", "showLargePopup"]),

        },
        beforeMount() {
            eventEmitter.$once("tokenSuccess", this.getApiData);
        },
        beforeDestroy() {
            if (this.e) {
                this.e.forEach(el => {
                    el.destroy();
                });
            }
            eventEmitter.$off("tokenSuccess", this.getApiData);
        },
        mounted() {
            if (this.tokenSuccess) {
                this.getApiData();
            } else {
                console.log("token is not success");
            }
            // preload.show();
        },
        watch: {
            '$route'(to, from) {
                if (this.tokenSuccess) {
                    this.getApiData();
                } else {
                    console.log("token is not success");
                }
            }
        }
    }
</script>


<style scoped>
    .bold {
        font-weight: 500;
    }

    .main {
        margin-top: 15px;
    }

    @media screen and (max-width: 600px) {
        .main {
            margin: 0;
        }

        h5 {
            font-size: 16px;
            margin-bottom: 0;
        }
    }

    input[type=text]:not(.browser-default) {
        border-bottom: 1px solid #d0d0d0;
        box-shadow: 0 1px 0 #d0d0d0;
    }

    input[type="text"]:not(.browser-default):focus:not([readonly]) {
        border-bottom: 1px solid #f0e8f1;
        box-shadow: 0 1px 0 #dfd8df;
    }

    label.white-text {
        color: #d0d0d0 !important;

    &
    .active {
        color: #fff !important;
    }

    }

    .hidden {
        display: none;
    }

    input[type="text"] {

    &
    :not(.browser-default):focus:not([readonly]) + label {
        color: #fff;
    }

    }

    .bg {
        background-color: rgba(56, 56, 56, 0.8);
    }

    [type="checkbox"]:checked + span:not(.lever):before {
        border: 2px solid transparent;
        border-right-color: white;
        border-bottom-color: white;
    }

    [type="checkbox"] + span:not(.lever):before {
        border: 2px solid white;
    }

    table.highlight > tbody > tr > td {
        padding: 7px 10px;
        font-size: 14px;
    }

    table.highlight > tbody > tr:hover {
        background-color: rgba(36, 37, 40, 0.51);
    }

    tr {
        cursor: pointer;
    }

    tr th {
        cursor: default;
    }

    tr td:first-child {
        font-weight: 600;
        text-transform: uppercase;
    }

    tr td:last-child {
        text-align: center;
    }

</style>